import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

const MsStarkySvg = React.forwardRef<SVGSVGElement, PropsTypeSvg>(
  ({ classNameProps, width, height }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns='http://www.w3.org/2000/svg'
        className={classNameProps}
        width={width}
        height={height}
        viewBox='0 0 100 100'
        fill='none'
      >
        <g clipPath='url(#clip0_1237_15837)'>
          <rect width='100' height='100' fill='none' />
          <path
            d='M28.6889 82.7074L31.6471 62.4321C31.9115 60.5863 31.0861 58.7775 29.5412 57.7523L12.4755 46.3672C8.86357 43.9488 10.0225 38.356 14.3119 37.6349L34.5034 34.2373C36.3324 33.961 37.7851 32.6014 38.2786 30.8212L43.8443 11.1188C44.9985 6.92215 50.6781 6.33756 52.7295 10.1866L62.3024 28.3039C63.1643 29.9339 64.9171 30.946 66.7597 30.8773L87.2362 30.109C91.5953 29.9611 93.8787 35.1432 90.8715 38.2699L76.5703 52.8623C75.2754 54.1798 74.8744 56.1466 75.4995 57.8398L82.624 77.075C84.1442 81.1502 79.8802 84.9503 75.9798 83.0314L57.5872 73.9446C55.9269 73.1193 53.9477 73.3089 52.4814 74.4608L36.4016 87.1603C33.059 89.827 28.1009 86.9644 28.6889 82.7074Z'
            fill='#FFCC00'
          />
          <path
            d='M56.7112 53.5173C56.7112 53.5173 55.2696 50.7552 51.1233 49.5389C47.5693 48.4963 44.8646 50.0422 44.8646 50.0422'
            stroke='#4C5052'
            strokeWidth='1.12235'
            strokeLinecap='round'
          />
          <circle
            cx='55.4684'
            cy='63.0606'
            r='1.40293'
            transform='rotate(-150 55.4684 63.0606)'
            fill='#4C5052'
          />
          <circle
            cx='42.3467'
            cy='55.4849'
            r='1.40293'
            transform='rotate(-150 42.3467 55.4849)'
            fill='#4C5052'
          />
          <path
            d='M58.7388 28.3979C66.0341 22.5056 77.5381 13.8074 78.9411 12.9656C80.1441 12.2438 80.6246 11.8433 82.5887 12.9656C84.5528 14.088 92.6898 19.1385 92.4092 19.9803C92.1286 20.8221 89.8839 19.4191 88.481 20.5415C87.3587 21.4394 75.6676 31.7649 69.9623 36.8155'
            stroke='#4C5052'
            strokeWidth='1.25703'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M45.1231 24.7505C42.0366 16.0523 38.1084 7.91529 37.2666 6.23177C36.6391 4.97696 36.6854 4.13734 34.4608 4.54826C32.2363 4.95917 21.5669 10.454 21.5538 11.3412C21.5407 12.2284 24.5283 11.4432 25.482 12.9659C26.245 14.184 32.2161 28.6787 35.4532 36.8181'
            stroke='#4C5052'
            strokeWidth='1.25703'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M32.925 50.2837C28.4356 52.4349 17.8855 56.7372 16.0898 56.7372C13.8451 56.7372 12.7227 56.176 11.6004 55.6148C10.478 55.0537 8.23335 55.0537 11.881 57.8595C9.41188 56.2882 8.04638 56.4566 7.67226 56.7372C7.48521 57.1113 7.89673 58.1962 11.0393 59.543C7.95273 58.4207 7.11097 57.5789 5.98862 58.4207C5.09074 59.0941 8.42037 61.133 10.1974 62.0683C8.70092 61.2266 5.14668 59.8237 4.02445 60.946C2.9022 62.0683 9.63662 65.716 11.0393 66.5577C12.442 67.3995 13.0036 67.9606 11.881 69.3636C10.7584 70.7665 10.7587 72.45 11.3197 72.7306C12.4419 73.292 14.1254 70.7665 16.3701 70.2053C18.6148 69.6442 31.5218 65.1548 33.4859 64.313'
            stroke='#4C5052'
            strokeWidth='1.25703'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M54.53 71.3276C54.53 77.0329 54.4739 88.6679 54.2494 89.5658C53.7584 91.5299 51.9112 94.0552 50.8824 95.7387H73.0487C71.9264 94.8034 69.5133 92.8206 68.8399 92.3716C67.9982 91.8105 67.9982 91.5299 67.9982 89.2852C67.9982 87.4894 67.9046 79.1841 67.9982 74.6947'
            stroke='#4C5052'
            strokeWidth='1.25703'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_1237_15837'>
            <rect width='100' height='100' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default MsStarkySvg;
